import { Typography } from '@global-engineering-shared/gweb-material-ui';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Filter from 'components/Filter/Filter';
import { defaultDates, useDates } from 'context/DateProvider/DateProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import { paramsArePresent } from 'context/SearchParamsProvider/utils/paramsArePresent';
import { useSnackbar } from 'context/SnackbarProvider/SnackbarProvider';
import FrameHealthContainer from 'features/Health/containers/FrameHealthContainer';
import MonetisationHealthContainer from 'features/Health/containers/MonetisationHealthContainer';

const HealthPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSnackbarInfo } = useSnackbar();
  const { searchParams } = useSearchParamsProvider();
  const { setDates } = useDates();

  useEffect(() => {
    if (!paramsArePresent(searchParams, 'from', 'to')) {
      setDates(defaultDates);
    }
  }, [searchParams]);

  useEffect(() => {
    if (location.state && location.state.invalidUrl) {
      setSnackbarInfo({
        severity: 'error',
        open: true,
        content: {
          header: 'Invalid URL',
          message: 'You have been redirected to the home page',
        },
      });
      navigate('.'); // Navigate back to this page and restore state
    }
  }, [location.state, setSnackbarInfo, navigate]);

  return (
    <main>
      <Filter></Filter>
      <Typography variant="h2" fontWeight="600">
        Health Dashboard
      </Typography>
      <FrameHealthContainer />
      <MonetisationHealthContainer />
    </main>
  );
};

export default HealthPage;
